import * as entity from '@common/domain/entities/RequisitionItem'
import * as app from '@framework/app';
import { IDataEndPoint, IFieldOptions, IEntityEndPoints, IColumnOptions, IGridOptions, IActionOptions, IToolbarOptions } from '@framework/interfaces/IEntity';
import { IApiServiceCommand } from '@services/api/api.service';
import { FormBuilderControlListHelper } from '../../formbuilder/FormBuilderControlListHelper';

import * as _ from 'underscore';
import { IPropertyFilter } from '../../formbuilder/PropertyFilter';
import { FormBuilderControl } from '../../formbuilder/FormBuilderControl';
import { FormBuilderControlType } from '../../formbuilder/FormBuilderControlType';
import { FieldType, ViewType, ActionType } from '../../../framework/core/Enums';
export class DetailedWipReportEndPoints extends entity.RequisitionItemEndPoints {
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/reports/detailedWipReport" }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/reports/detailedWipReportCount" }, method: "POST" };
  exportToExcel?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/reports/detailedWipReportToExcel" }, method: "POST" };
}



export class DetailedWipReportListColumns extends Array<IColumnOptions> {
	constructor() {
		super();
		try {
			var id = FormBuilderControlListHelper.getListColumn("id", "id", null, null, "id");
			//id.visible = false;
			id.visible = function () {
				return false;
			}
			var category = FormBuilderControlListHelper.getListColumn("category", "category", null, null, "category");
			//category.visible = false;
			category.visible = function () {
				return false;
			}
			var workOrderNo = FormBuilderControlListHelper.getListColumn("workOrderNo", "WorkOrder No", null, null, null);
			workOrderNo.filter = false;
			workOrderNo.search = false;
			this.push(workOrderNo);
			var jobCardNo = FormBuilderControlListHelper.getListColumn("jobCardNo", "Job Card No", null, null, null);
			jobCardNo.filter = false;
			this.push(jobCardNo);
			var amount = FormBuilderControlListHelper.getListColumn("amount", "Amount", null, null, "amount");
			amount.visible = function () { return false};

			var amountFormatted = FormBuilderControlListHelper.getListColumn("amountFormatted", "Amount", null, null, "amountFormatted");
			this.push(amountFormatted);

			var invoiceNr = FormBuilderControlListHelper.getListColumn("invoiceNr", "Invoice No", null, null, "invoiceNr");
			this.push(invoiceNr);

			var buildAmount = FormBuilderControlListHelper.getListColumn("scaffoldAmounts.buildAmount", "Build Amount", null, null, "scaffoldAmounts_buildAmount");
			this.push(buildAmount);

			var hireEst = FormBuilderControlListHelper.getListColumn("scaffoldAmounts.hireAmountEstimate", "Hire Amount (based on estimate): ", null, null, "scaffoldAmounts_hireAmountEstimate");
			this.push(hireEst);

			var hireAct = FormBuilderControlListHelper.getListColumn("scaffoldAmounts.hireAmountActual", "Hire Amount (based on actual):", null, null, "scaffoldAmounts_hireAmountActual");
			this.push(hireAct);
			this.push(id);
			this.push(amount);
			this.push(category);
		} catch  {

		}
	}
}
export class DetailedWIPReportStaticFilters extends Array<IPropertyFilter> {
	constructor() {
		super();
		let jobNumber = new FormBuilderControl();
		jobNumber.controlType = { viewType: ViewType.Dropdown  };
		jobNumber.displayName = "Job Number";
		jobNumber.bindingValue = "jobNumber";
		jobNumber.field = "jobNumber";
		jobNumber.fieldOptions = { dataEndPoint: {url: app.config.controllerRouteRoot + "/projectJobNumber/dropdown" }}
		jobNumber.fieldOptions.dataDisplayField = "sysproJobNo";
		jobNumber.fieldOptions.dataIdField = "id";
		jobNumber.show = function (scope) {
			return true;
		};
		this.push({ control: jobNumber, filterValue: '', whereFilterType: 1, columnName: "jobNumber" });

		let dateFrom = new FormBuilderControl();
		dateFrom.controlType = { viewType: ViewType.Date };
		dateFrom.bindingValue = "dateFrom";
		dateFrom.field = "dateFrom";
		dateFrom.displayName = "Date From";
		dateFrom.fieldOptions = {
			default: function () {
				let date = new Date();
				let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
				return firstDay;
			}
		};
		this.push({ control: dateFrom, filterValue: '', whereFilterType: 1, columnName: "dateFrom" });

		let dateTo = new FormBuilderControl();
		dateTo.controlType = { viewType: ViewType.Date };
		dateTo.bindingValue = "dateTo";
		dateTo.field = "dateTo";
		dateTo.displayName = "Date To";
		dateTo.fieldOptions = {
			default: function () {
				let date = new Date();
				let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
				return lastDay;
			}
		};
		this.push({ control: dateTo, filterValue: '', whereFilterType: 1, columnName: "dateTo" });
	}
}

export class DetailedWipReportList implements IGridOptions {


	public get model(): any { return { fields: {} } };
	public disableNavigation: boolean = true;
	protected requisitionItemListName: string = "detailedWipReportList";
	protected requisitionItemListEndPoints: DetailedWipReportEndPoints = new DetailedWipReportEndPoints();
	protected requisitionItemListColumns: DetailedWipReportListColumns = new DetailedWipReportListColumns();
	public get name(): string { return this.requisitionItemListName };
	public get endPoints(): IEntityEndPoints { return this.requisitionItemListEndPoints };
	public set endPoints(requisitionItemEndPoints: IEntityEndPoints) {
		this.requisitionItemListEndPoints = requisitionItemEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): DetailedWipReportListColumns { return this.requisitionItemListColumns };
	public tableIsGrouped: boolean = true;
	public get rowHeight(): number { return 15 };
	public rowCount: any = 50000;
	public groupingField: string = 'category';
	public groupingSubtotalCalcField: string = 'amount';
	public groupingSubtotalCalcFunc: any = function (items) {
		var total = 0;
		var excl = 0;
		let paint: boolean = false;
		let insulation: boolean = false;
		items.forEach(o => {
			let category: string = o["category"];
			if (category.includes("Paint")) paint = true;
			if (category.includes("Insulation")) insulation = true;
			if (o["amount"])
				excl += o["amount"]
			if (o["amount"])
				total += o["amount"]
		});
		if (paint || insulation) total = total / 2;
		return "R " + total.toLocaleString();
	};
	public autoExpandRows: boolean = false;

	public get staticFilters(): Array<IPropertyFilter> { return new DetailedWIPReportStaticFilters() };
  public canAdd: boolean = false;
}



